import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCurrentPage,
  getApiParams,
} from "../../../NetworkPortal/ProviderProfileDetails/helper";
import { useEffect } from "react";
import {
  CSVData,
  TestExcelHeader,
  TestExcelHeaderColmns,
  initialFilterState,
  initialHeaderTest,
} from "./helper";
import Modal from "react-modal";
import {
  getHVChargesForAction,
  getSkuTestPackagesAction,
  getTestPackageExcelAction,
  getTestTypeAction,
} from "../../../../redux/actions/TestPackagesAction";
import { ExcelIconTest, SearchIcon } from "../../../../Utils/SvgIcons";
import { ChooseToFilterTestPopup } from "./ChooseToFilterTestPopup";
import { UploadExcelTestPopup } from "./UploadExcelTestPopup";
import { AddQuicklyTestSKUPopup } from "./AddQuicklyTestSKUPopup";
import PaginatedItems from "../../../../common/Pagination";
import { isLoadingAction } from "../../../../Utils/helper";
import { CSVLink } from "react-csv";
import {
  SubmitApprovalRequestAction,
  ViewRequestStatusAction,
} from "../../../../redux/actions/GlobalAction";

const Test = () => {
  const dispatch = useDispatch();
  const [showHeaderTestArray, setShowHeaderTestArray] =
    useState(initialHeaderTest);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [searchFilter, setSearchFilter] = useState(initialFilterState);
  const [isAddSku, setIsAddSku] = useState(false);
  const [providerSKUTestMapStgId, setProviderSKUTestMapStgId] = useState(null);
  const [providerPermanentTestMapStgId, setProviderPermanentTestMapStgId] =
    useState(null);
  const [facilityId, setFacilityId] = useState(null);
  const [isChooseToFilter, setIsChooseToFilter] = useState(false);
  const [isUploadExcel, setIsUploadExcel] = useState(false);
  const [userDetail, setUserDetail] = useState(null);

  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const { apiParams } = getApiParams({ globalReducer });

  useEffect(() => {
    dispatch(getHVChargesForAction());
    dispatch(getTestTypeAction());
  }, []);

  useEffect(() => {
    dispatch(getSkuTestPackagesAction({ ...searchFilter, ...apiParams }));
  }, [globalReducer?.getCurrentPage]);

  const handleSearch = () => {
    clearCurrentPage(dispatch);
    dispatch(
      getSkuTestPackagesAction({ ...searchFilter, ...apiParams, page: 1 })
    );
  };

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  const handleClearFilter = () => {
    setSearchFilter(initialFilterState);
    dispatch(getSkuTestPackagesAction(initialFilterState));
    clearCurrentPage(dispatch);
  };

  const ExportToExcelHandler = async () => {
    setIsLoadingExcel(true);
    const resp = dispatch(
      getTestPackageExcelAction({
        centreSKUCode: searchFilter?.centreSKUCode,
        centreSKUName: searchFilter?.centreSKUName,
        requeststatus: searchFilter?.RequestStatus,
        sortDirection: "desc",
      })
    );
    resp?.then((res) => {
      if (res?.data?.status === true) {
        setExcelSheetData(res?.data?.results?.lstSKUDetails);
        setIsLoadingExcel(false);
      } else {
        setIsLoadingExcel(false);
      }
      setTimeout(() => {
        document.getElementById("exportexcel").click();
      }, 500);
    });
  };

  return (
    <>
      <div className="row-filter">
        <input
          type="text"
          placeholder="Test Name"
          className="white-form-select"
          value={
            searchFilter?.centreSKUName === null
              ? ""
              : searchFilter?.centreSKUName
          }
          onChange={(e) => changeHandler("centreSKUName", e.target.value)}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              handleSearch(event);
            }
          }}
        />
        <input
          type="text"
          className="white-form-select"
          placeholder="Test Code"
          value={
            searchFilter?.centreSKUCode === null
              ? ""
              : searchFilter?.centreSKUCode
          }
          onChange={(e) => changeHandler("centreSKUCode", e.target.value)}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              handleSearch(event);
            }
          }}
        />
        <select
          style={{ padding: "8px" }}
          name="gender"
          className="white-form-select"
          value={
            searchFilter?.RequestStatus === null
              ? ""
              : searchFilter?.RequestStatus
          }
          onChange={(e) => changeHandler("RequestStatus", e.target.value)}
        >
          <option value="">Select Status</option>
          <option value="UnMapped">UnMapped</option>
          <option value="Not Submitted">Not Submitted</option>
          <option value="Pending For Approval">Pending For Approval</option>
          <option value="Accepted">Accepted</option>
          <option value="Rejected">Rejected</option>
        </select>
        <div className="search" type="button" onClick={handleSearch}>
          <a className="sidebar-links">
            <SearchIcon />
            <span className="sidebar-link-text" style={{ color: "white" }}>
              Search
            </span>
          </a>
        </div>
        <div className="search" type="button" onClick={handleClearFilter}>
          <a className="sidebar-links">
            <span className="sidebar-link-text" style={{ color: "white" }}>
              Clear All
            </span>
          </a>
        </div>
      </div>
      <div className="row-results">
        <div className="results">
          Total <span>{globalReducer?.getTotalCount}</span> results
        </div>
        <div className="d-flex gap-10">
          <button
            className={`btn search__btn`}
            type="button"
            onClick={() => setIsAddSku(true)}
          >
            <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp;
            {window.innerWidth <= 700 ? "Add" : "Quickly Add SKUs"}
          </button>
          <button
            className={`btn ${
              !isLoadingExcel ? "search__btn" : "disabled_btn"
            }`}
            type="button"
            onClick={ExportToExcelHandler}
          >
            <i className="fa-solid fa-arrow-down"></i>&nbsp;
            {isLoadingExcel
              ? window.innerWidth <= 700
                ? "Export"
                : "Exporting..."
              : window.innerWidth <= 700
              ? "Excel"
              : "Export To Excel"}
          </button>
          <CSVLink
            style={{ display: "none" }}
            id="exportexcel"
            data={CSVData(excelSheetData)}
            headers={TestExcelHeader}
            filename={"providerSKUtestdetails.csv"}
          ></CSVLink>
          <button
            className={`btn search__btn`}
            type="button"
            onClick={() => setIsUploadExcel(true)}
          >
            <i className="fas fa-file-upload pt-1"></i>&nbsp;
            {window.innerWidth <= 700 ? "Import" : "Import SKU"}
          </button>
        </div>
      </div>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              {showHeaderTestArray?.map((ele, index) => {
                return (
                  <th scope="col" key={index}>
                    {ele}
                  </th>
                );
              })}
              <th>Status</th>
              <th
                style={{ cursor: "pointer" }}
                onClick={() => setIsChooseToFilter(true)}
              >
                <img
                  src={
                    window.location.pathname.includes("campaigns")
                      ? "../../images/settings.png"
                      : "./images/settings.png"
                  }
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {TestPackageReducer?.getSkuTestPackagesDetails?.lstSKUDetails?.map(
              (ele, index) => {
                return (
                  <tr key={index}>
                    {showHeaderTestArray?.map((col) => (
                      <td>
                        {col === "Outsourced"
                          ? ele.isOutSourced
                            ? "Yes"
                            : "No"
                          : ele[TestExcelHeaderColmns[col]] === null
                          ? "-"
                          : ele[TestExcelHeaderColmns[col]]}
                      </td>
                    ))}
                    <td>
                      <span
                        className={`${
                          ele?.requestStatus === "Pending For Approval"
                            ? "pending-status"
                            : ele?.requestStatus === "Accepted"
                            ? "accepted-status"
                            : ele?.requestStatus === "Rejected"
                            ? "rejected-status"
                            : ele?.requestStatus === "UnMapped"
                            ? "unmapped-status"
                            : "notsubmited-status"
                        }`}
                      >
                        {ele?.requestStatus === null
                          ? "-"
                          : ele?.requestStatus === "Pending For Approval"
                          ? "Pending"
                          : ele?.requestStatus}
                      </span>
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setIsAddSku(true);
                        setProviderSKUTestMapStgId(
                          ele?.providerSKUTestMapStgId
                        );
                        setProviderPermanentTestMapStgId(
                          ele?.providerSKUTestId
                        );
                        setFacilityId(ele?.facilityId);
                        setUserDetail(ele);
                      }}
                    >
                      <img
                        src={
                          window.location.pathname.includes("campaigns")
                            ? "../../images/edit-icon.png"
                            : "./images/edit-icon.png"
                        }
                      />
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination-row">
        {globalReducer?.getTotalCount !== 0 && (
          <PaginatedItems
            totalCount={globalReducer?.getTotalCount}
            perPageData={searchFilter?.rows}
          />
        )}
      </div>
      <div className="mb-2 text-end">
        {TestPackageReducer?.getSkuTestPackagesDetails?.isShowSubmitButton && (
          <button
            className="btn btn-primary"
            type="button"
            onClick={async () => {
              await dispatch(SubmitApprovalRequestAction("TestDetail"));
              dispatch(
                getSkuTestPackagesAction({ ...searchFilter, ...apiParams })
              );
              await dispatch(ViewRequestStatusAction("TestDetail"));
            }}
          >
            SUBMIT
          </button>
        )}
      </div>
      <Modal
        isOpen={isAddSku}
        className="modal-add-user-popup modal-role-user-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <AddQuicklyTestSKUPopup
          setIsAddSku={setIsAddSku}
          setProviderSKUTestMapStgId={setProviderSKUTestMapStgId}
          setProviderPermanentTestMapStgId={setProviderPermanentTestMapStgId}
          providerSKUTestMapStgId={providerSKUTestMapStgId}
          providerPermanentTestMapStgId={providerPermanentTestMapStgId}
          searchFilter={searchFilter}
          apiParams={apiParams}
          setFacilityId={setFacilityId}
          facilityId={facilityId}
          userDetail={userDetail}
        />
      </Modal>
      <Modal
        isOpen={isChooseToFilter}
        className="modal-add-user-popup modal-role-user-popup modal-choose-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <ChooseToFilterTestPopup
          setIsChooseToFilter={setIsChooseToFilter}
          showHeaderTestArray={showHeaderTestArray}
          setShowHeaderTestArray={setShowHeaderTestArray}
        />
      </Modal>
      <Modal
        isOpen={isUploadExcel}
        className="modal-add-user-popup modal-upload-excel-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <UploadExcelTestPopup setIsUploadExcel={setIsUploadExcel} />
      </Modal>
    </>
  );
};

export default Test;
